import { render, staticRenderFns } from "./ClientsDataTable.vue?vue&type=template&id=3223e866&scoped=true&"
import script from "./ClientsDataTable.vue?vue&type=script&lang=ts&"
export * from "./ClientsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsDataTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientsDataTable.vue?vue&type=style&index=1&id=3223e866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223e866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VContainer,VDataTable,VIcon})
